<div class="hamburger-container">
  <mat-sidenav-container class="fullHeightWorkspace">
    <mat-sidenav
      #sidenav
      mode="over"
      position="end"
      [opened]="localTrendsFacade.getOpenLocalTrendsStatus() | async"
      disableClose
    >
      <div class="propdetails_base container newContainer text-left">
        <div class="SideToolbar">
          <div class="btn-block">
            <h4 class="inline">Local Market Insights</h4>
            <!-- <i matRipple class="material-icons pull-right" style="cursor: pointer;" (click)="onClose()">cancel</i> -->
            <div class="prop_dtls_closeBtn pull-right" (click)="onClose()">
              <img src="../assets/images/close.svg" />
            </div>
          </div>
        </div>
        <div class="SideContent">
          <!-- Local Trends -->

          <div class="w-100 fullHeight">
            <div class="container fullHeight px-0">
              <div class="w-100">
                <section>
                  <div>
                    <div class="whiteWrap">
                      <div class="profileTabModule">
                        <mat-tab-group (selectedTabChange)="tabChanged($event)" [(selectedIndex)]="setInitialTab">
                          <ng-container *ngFor="let zipCode of zipCodeList">
                            <mat-tab label="{{ zipCode }}">
                              <div *ngIf="!localTrendsLoaderStatus">
                                <iframe [src]="localTrendsForZipUrl" height="2460" width="100%"></iframe>
                              </div>
                            </mat-tab>
                          </ng-container>
                        </mat-tab-group>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-sidenav>
  </mat-sidenav-container>
</div>
